export default [
  {
    path: '/order_commissions',
    name: 'order_commissions.index',
    component: require('./index').default,
    meta: {
      title: '佣金记录管理',
      navbar: 'el-icon-money',
      permission: 'order_commissions.read'
    }
  },
  {
    path: '/order_commissions/:id',
    name: 'order_commissions.show',
    component: require('./show').default,
    meta: {
      title: '佣金记录详情',
      permission: 'order_commissions.read'
    }
  },
]
